import type {
	GroupedParametrics,
	ParametricListInfo,
	ParametricListValue,
	ParametricListValuewithCount,
	Pricelist,
	Product,
	ProductItem,
	SimplifiedProductRelations
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { defineStore, acceptHMRUpdate } from "pinia";

interface State {
	selectedColor: ParametricListValue | ParametricListValuewithCount | null;
	selectedSecondParametric: ParametricListValue | undefined;
	products: Product | null;
	selectedProduct: Product | undefined;
	parametrics: GroupedParametrics;
	parametricsInformation: ParametricListInfo[];
	defaultProductImage: string;
	priceLists: Pricelist[];
	relations: SimplifiedProductRelations[];
	lowestPrice: number | null;
	productType: string | null;
	bundleProducts: ProductItem[];
}
export const useProductStore = defineStore({
	id: "productStore",
	state: (): State => {
		return {
			selectedColor: null,
			selectedSecondParametric: undefined,
			products: null,
			selectedProduct: undefined,
			parametrics: {},
			parametricsInformation: [],
			defaultProductImage: "",
			priceLists: [],
			relations: [],
			lowestPrice: null,
			productType: null,
			bundleProducts: []
		};
	},
	actions: {
		setPriceLists(priceLists: Pricelist[]) {
			this.priceLists = priceLists.filter(
				(priceList: Pricelist) => priceList.IsPublic
			);
		},
		addSelectedColor(
			value: ParametricListValue | ParametricListValuewithCount
		) {
			this.selectedColor = value;
		},
		addSelectedSecondParametric(value: ParametricListValue) {
			this.selectedSecondParametric = value;
		},
		addProducts(value: Product) {
			this.products = value;
		},
		addSelectedProduct(value: Product | undefined) {
			this.selectedProduct = value;
		},
		addParametrics(value: GroupedParametrics) {
			this.parametrics = value;
		},
		addRelations(value: SimplifiedProductRelations[]) {
			this.relations = value;
		},
		addLowestPrice(value: number | null) {
			this.lowestPrice = value;
		},
		async addParametricsInformation(value: ParametricListInfo[]) {
			this.parametricsInformation = value;
		},
		async addDefaultProductImage(value: string) {
			this.defaultProductImage = value;
		},
		setProductType(value: string | null) {
			this.productType = value;
		},
		addBundleProducts(value: ProductItem[]) {
			this.bundleProducts = value;
		}
	},
	getters: {
		getSelectedColor: (state) => state.selectedColor,
		getSelectedSecondParametric: (state) => state.selectedSecondParametric,
		getProducts: (state) => state.products,
		getSelectedProduct: (state) => state.selectedProduct,
		getParametrics: (state) => state.parametrics,
		getParametricsInformation: (state) => state.parametricsInformation,
		getDefaultProductImage: (state) => state.defaultProductImage,
		getRelations: (state) => state.relations,
		getLowestPrice: (state) => state.lowestPrice
	}
});
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useProductStore, import.meta.hot));
}
